export const addTrailingSlash = <T extends string | undefined>(s: T) =>
  (typeof s === 'string' && s.indexOf('/', s.length - 1) === -1
    ? `${s}/`
    : s) as T extends string ? string : T;
